/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
function getParam(p) {
  const match = RegExp(`[?&]${p}=([^&]*)`).exec(window.location.search);

  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function getExpiryRecord(value) {
  // Validade de 90 dias em milésimos de segundo
  const expiryPeriod = 90 * 24 * 60 * 60 * 1000;

  const expiryDate = new Date().getTime() + expiryPeriod;
  return { value, expiryDate, inclusionDate: new Date() };
}

function isValidUtm(utm?: any, urlParams?: any) {
  const requiredParams = ['utm_campaign', 'utm_source', 'utm_medium'];

  if (utm) {
    return requiredParams.every((param) => utm[param]);
  }

  if (urlParams) {
    return requiredParams.every((param) => urlParams.get(param));
  }

  return false;
}

function compareUtm(utm1, utm2, params) {
  if (!utm1 || !utm2 || utm1.length !== utm2.length) {
    return false;
  }

  return params.every((param) => utm1[param] === utm2[param]);
}

function getCookie(name) {
  const cookie = {};

  document.cookie.split(';').forEach((el) => {
    const [k, v] = el.split('=');
    cookie[k.trim()] = v;
  });

  return cookie[name];
}

function addFbclid() {
  const fbc = getCookie('_fbc');
  if (!fbc) {
    return;
  }

  const fbRecord = {
    value: fbc.split('.')[3],
    inclusionDate: parseInt(fbc.split('.')[2]),
  };

  const stringFbc = localStorage.getItem('fbclid');
  let fbclid = stringFbc ? JSON.parse(stringFbc) : [];
  if (!fbclid?.length) {
    fbclid = [fbRecord];
  } else if (fbclid && !fbclid.some((item) => item.value === fbRecord.value)) {
    fbclid.push(fbRecord);
  }

  if (fbclid.length) {
    localStorage.setItem('fbclid', JSON.stringify(fbclid));
    return fbclid;
  }
}

function addGclid() {
  const gclidParam = getParam('gclid');

  const stringGc = localStorage.getItem('gclid');
  let gclid = stringGc ? JSON.parse(stringGc) : [];
  if (!Array.isArray(gclid)) {
    gclid = [gclid];
  }

  if (gclidParam && !gclid.some((item) => item.value === gclidParam)) {
    const gclidRecord = getExpiryRecord(gclidParam);
    gclid.push(gclidRecord);
  }

  const now = new Date();
  gclid = gclid.filter((item, index, array) => {
    const indexItem = array.findIndex((arrayItem) => arrayItem.value === item.value);
    return indexItem === index && now.getTime() < item.expiryDate;
  });

  if (gclid.length) {
    localStorage.setItem('gclid', JSON.stringify(gclid));
    return gclid;
  }
}

function addUTM() {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = ['utm_campaign', 'utm_source', 'utm_medium', 'utm_content', 'utm_id', 'utm_term'];

  const oldObject = {};
  const utmObject = {};
  utmParams.forEach((utmParam) => {
    const utmParamValue = urlParams.get(utmParam);
    const oldValue = sessionStorage.getItem(utmParam);

    utmObject[utmParam] = utmParamValue;
    oldObject[utmParam] = oldValue;

    if (oldValue) {
      sessionStorage.removeItem(utmParam);
    }
  });

  const stringUtm = localStorage.getItem('params');
  const utmValues = stringUtm ? JSON.parse(stringUtm) : [];
  const oldKeys = Object.keys(oldObject);
  if (oldKeys.length && isValidUtm(oldObject) && !utmValues.some((value) => compareUtm(value, oldObject, utmParams))) {
    utmValues.push(oldObject);
  }

  if (isValidUtm(utmObject) && !utmValues.some((value) => compareUtm(value, utmObject, utmParams))) {
    utmValues.push(utmObject);
  }

  if (utmValues.length) {
    localStorage.setItem('params', JSON.stringify(utmValues));
    return utmValues;
  }
}

function clearSearchParams() {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;

  const deleteKeys: string[] = [];
  const deleteParams = [
    'utm_campaign',
    'utm_source',
    'utm_medium',
    'utm_content',
    'utm_id',
    'utm_term',
    'gclid',
    'fbclid',
    'creative',
    'device',
    'loc_physical_ms',
    'feeditemid',
    'matchtype',
    'placement',
    'gad_source',
  ];

  searchParams.forEach((_, key) => {
    if (deleteParams.every((param) => param !== key)) return;

    deleteKeys.push(key);
  });

  if (!deleteKeys.length) return;

  deleteKeys.forEach((key) => searchParams.delete(key));
  window.history.replaceState({}, '', url);
}

export function setCampaignParameters(): void {
  addUTM();
  addGclid();
  addFbclid();

  clearSearchParams();
}

export function getCampaignParameters(): any {
  const parameters: any = {};

  const utmParams = localStorage.getItem('params');
  if (utmParams) {
    parameters.utmParams = JSON.parse(utmParams);
  }

  const gclid = localStorage.getItem('gclid');
  if (gclid) {
    parameters.gclid = JSON.parse(gclid);
  }

  const fbclid = localStorage.getItem('fbclid');
  if (fbclid) {
    parameters.fbclid = JSON.parse(fbclid);
  }

  parameters.userAgent = window.navigator.userAgent;
  parameters.screenWidth = window.innerWidth > 0 ? window.innerWidth : screen.width;
  parameters.screenHeigth = window.innerHeight > 0 ? window.innerHeight : screen.height;
  parameters.url = window.location.href;
  parameters.title = document.title;

  return parameters;
}
